export default "__VITE_ASSET__CkRtbP2w__"